import { memo } from 'react';

export const Article = memo(({ message }) => {
  return message.text;
});
